var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"min-h-screen"},[_c('Navbar'),_c('TherapyHero'),_c('TherapyMain'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }